const KATAKANA_REGEX = /^([ァ-ヾ]|ー)+$/g;

const validateFullWidthKatakana = (value?: string) => {
  if (!value) return true;
  return value.match(KATAKANA_REGEX);
};

export default validateFullWidthKatakana;
